/**
 * Jackery Dawn — Global theme JS
 * Header scroll, mobile menu, section reveal
 */

(function() {
  'use strict';

  // ============================================================
  // Sticky header scroll state
  // ============================================================
  var header = document.getElementById('site-header');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.scrollY;
      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ============================================================
  // Mobile menu
  // ============================================================
  var mobileNav = document.getElementById('mobile-nav');
  var menuOverlay = document.getElementById('menu-overlay');
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuOverlay) menuOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuOverlay) menuOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  // ============================================================
  // Section reveal on scroll (IntersectionObserver)
  // ============================================================
  function initReveal() {
    var revealElements = document.querySelectorAll('.reveal');
    if (revealElements.length === 0) return;

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px 50px 0px' });

      revealElements.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 50) {
          // Already in viewport — reveal immediately, skip observer
          el.classList.add('is-visible');
        } else {
          revealObserver.observe(el);
        }
      });
    } else {
      revealElements.forEach(function(el) {
        el.classList.add('is-visible');
      });
    }

    // Safety net: reveal all after 800ms
    setTimeout(function() {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function(el) {
        el.classList.add('is-visible');
      });
    }, 800);
  }

  initReveal();

  function cleanupOpenStates() {
    document.body.style.overflow = '';
    // Cart/menu overlay (.overlay + is-active)
    var cartOverlay = document.getElementById('cart-overlay');
    if (cartOverlay) cartOverlay.classList.remove('is-active');
    var menuOverlay = document.getElementById('menu-overlay');
    if (menuOverlay) menuOverlay.classList.remove('is-active');
    // Search overlay (uses is-open, not is-active)
    var searchOverlay = document.getElementById('search-overlay');
    if (searchOverlay) {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
    }
    // Mobile nav
    var nav = document.getElementById('mobile-nav');
    if (nav) {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
    }
    // Cart drawer
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
  }

  // Fix bfcache: po back/forward navigaci observer neexistuje — odhal vše okamžitě
  // a resetuj veškerý scroll-lock / overlay stav z předchozí navigace
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      document.querySelectorAll('.reveal').forEach(function(el) {
        el.classList.add('is-visible');
      });
      cleanupOpenStates();
    }
  });

  // Před vstupem do bfcache ukliď otevřené stavy (drawer, menu, search, scroll lock)
  window.addEventListener('pagehide', cleanupOpenStates);

  // ============================================================
  // Announcement bar rotation
  // ============================================================
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    var abMessages = announcementBar.querySelectorAll('.announcement-bar__text');
    var abNext = announcementBar.querySelector('[data-announcement-next]');
    var abPrev = announcementBar.querySelector('[data-announcement-prev]');

    if (abMessages.length > 1) {
      var abCurrent = 0;
      var abCount = abMessages.length;
      var abInterval;

      function goToMessage(index) {
        abMessages[abCurrent].classList.remove('is-active');
        abCurrent = (index + abCount) % abCount;
        abMessages[abCurrent].classList.add('is-active');
      }

      function nextMessage() { goToMessage(abCurrent + 1); }
      function prevMessage() { goToMessage(abCurrent - 1); }

      if (abNext) abNext.addEventListener('click', function() { nextMessage(); resetAbAutoplay(); });
      if (abPrev) abPrev.addEventListener('click', function() { prevMessage(); resetAbAutoplay(); });

      function startAbAutoplay() { abInterval = setInterval(nextMessage, 5000); }
      function resetAbAutoplay() { clearInterval(abInterval); startAbAutoplay(); }
      startAbAutoplay();
    }
  }

  // ============================================================
  // Hero slideshow
  // ============================================================
  var heroSlides = document.querySelectorAll('.hero__slide');
  var heroDots = document.querySelectorAll('.hero__dot');
  var heroNext = document.querySelector('[data-hero-next]');
  var heroPrev = document.querySelector('[data-hero-prev]');

  if (heroSlides.length > 1) {
    var currentSlide = 0;
    var slideCount = heroSlides.length;
    var autoplayInterval;
    var heroSection = document.querySelector('.hero[data-autoplay-speed]');
    var autoplaySpeed = heroSection ? parseInt(heroSection.getAttribute('data-autoplay-speed')) || 6000 : 6000;

    function goToSlide(index) {
      heroSlides[currentSlide].classList.remove('is-active');
      if (heroDots[currentSlide]) heroDots[currentSlide].classList.remove('is-active');
      currentSlide = (index + slideCount) % slideCount;
      heroSlides[currentSlide].classList.add('is-active');
      if (heroDots[currentSlide]) heroDots[currentSlide].classList.add('is-active');
    }

    function nextSlide() { goToSlide(currentSlide + 1); }
    function prevSlide() { goToSlide(currentSlide - 1); }

    if (heroNext) heroNext.addEventListener('click', function() { nextSlide(); resetAutoplay(); });
    if (heroPrev) heroPrev.addEventListener('click', function() { prevSlide(); resetAutoplay(); });

    heroDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.getAttribute('data-hero-dot')));
        resetAutoplay();
      });
    });

    // Autoplay
    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, autoplaySpeed);
    }
    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }
    startAutoplay();
  }

})();

// Page navigation progress bar — shows only if navigation takes >150ms
(function() {
  var bar = document.createElement('div');
  bar.id = 'nav-progress';
  document.body.appendChild(bar);

  var showTimer, crawlTimer;
  var pending = false;

  function start() {
    clearTimeout(showTimer);
    clearTimeout(crawlTimer);
    pending = true;
    // Only make bar visible after 150ms — fast pages never show it
    showTimer = setTimeout(function() {
      bar.style.transition = 'none';
      bar.style.opacity = '1';
      bar.style.width = '0';
      requestAnimationFrame(function() {
        bar.style.transition = 'width 0.15s ease';
        bar.style.width = '25%';
        crawlTimer = setTimeout(function() {
          bar.style.transition = 'width 10s cubic-bezier(0.04, 0.8, 0.16, 1)';
          bar.style.width = '82%';
        }, 150);
      });
    }, 150);
  }

  function cancel() {
    clearTimeout(showTimer);
    clearTimeout(crawlTimer);
    pending = false;
    bar.style.cssText = '';
  }

  function finish() {
    clearTimeout(showTimer);
    clearTimeout(crawlTimer);
    if (!pending) return;
    pending = false;
    bar.style.transition = 'width 0.12s ease';
    bar.style.width = '100%';
    setTimeout(function() {
      bar.style.transition = 'opacity 0.25s ease';
      bar.style.opacity = '0';
    }, 120);
  }

  document.addEventListener('click', function(e) {
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return;
    try {
      var url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    } catch (err) { return; }
    // Odlož na další tick: jiný handler (cart drawer toggle, modal…) mohl klik
    // preventDefaultnout → navigace nenastane → bar NEspouštět, jinak visí donekonečna
    // (nepřijde pagehide → finish()). Bug: ikona košíku je <a href="/cart"> s preventDefault.
    setTimeout(function() {
      if (e.defaultPrevented) return;
      start();
    }, 0);
  });

  window.addEventListener('pagehide', function(e) {
    if (e.persisted) { cancel(); } else { finish(); }
  });
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) { cancel(); }
  });
}());
